var _style, _g, _path, _path2, _path3, _path4, _g2, _g3, _g4, _g5, _path5, _path6, _g6, _g7, _g8, _g9, _g10, _g11, _path7, _path8, _path9, _g12, _path10, _path11, _path12, _path13, _path14, _linearGradient, _path15, _path16, _path17, _path18, _path19, _path20, _ellipse, _ellipse2, _ellipse3, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgConnectionError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 786.8 676.4",
    style: {
      maxWidth: 300
    }
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".connection-error_svg__st0{opacity:.8}.connection-error_svg__st2{fill:#fff}.connection-error_svg__st3{fill:#64ffda}.connection-error_svg__st6{opacity:.5}.connection-error_svg__st7{fill:#c6c6c6}.connection-error_svg__st8{opacity:.4}.connection-error_svg__st9{opacity:.3}.connection-error_svg__st14{fill:none;stroke:#c1c1c1;stroke-width:2;stroke-miterlimit:10;stroke-dasharray:12}.connection-error_svg__st16{fill:#3f3d56}.connection-error_svg__st17{fill:#3751ff}.connection-error_svg__st18{fill:#f2f2f2}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "connection-error_svg__st0"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "connection-error_svg__SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 660.5,
    y1: 530.72,
    x2: 660.5,
    y2: 72,
    gradientTransform: "translate(-79.24 -72)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#connection-error_svg__SVGID_1_)",
    d: "M375.8 0H786.8V458.7H375.8z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "connection-error_svg__st2",
    d: "M382.5 306.3H779.9V448.8H382.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "connection-error_svg__st3",
    d: "M415.2 340.1H430.59999999999997V413.1H415.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "connection-error_svg__st3",
    d: "M445.6 340.1H461V413.1H445.6z",
    opacity: 0.7
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "connection-error_svg__st3",
    d: "M476 340.1H491.4V413.1H476z",
    opacity: 0.6
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "connection-error_svg__st6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "connection-error_svg__st7",
    d: "M514.1,340.1L514.1,340.1c4.3,0,7.7,3.4,7.7,7.7v57.6c0,4.3-3.4,7.7-7.7,7.7l0,0c-4.3,0-7.7-3.4-7.7-7.7v-57.6 C506.4,343.5,509.8,340.1,514.1,340.1z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "connection-error_svg__st6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "connection-error_svg__st7",
    d: "M544.5,340.1L544.5,340.1c4.3,0,7.7,3.4,7.7,7.7v57.6c0,4.3-3.4,7.7-7.7,7.7l0,0c-4.3,0-7.7-3.4-7.7-7.7v-57.6 C536.8,343.5,540.2,340.1,544.5,340.1z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "connection-error_svg__st8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "connection-error_svg__st7",
    d: "M574.9,340.1L574.9,340.1c4.3,0,7.7,3.4,7.7,7.7v57.6c0,4.3-3.4,7.7-7.7,7.7l0,0c-4.3,0-7.7-3.4-7.7-7.7v-57.6 C567.2,343.5,570.6,340.1,574.9,340.1z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "connection-error_svg__st9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "connection-error_svg__st7",
    d: "M605.3,340.1L605.3,340.1c4.3,0,7.7,3.4,7.7,7.7v57.6c0,4.3-3.4,7.7-7.7,7.7l0,0c-4.3,0-7.7-3.4-7.7-7.7v-57.6 C597.6,343.5,601,340.1,605.3,340.1z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "connection-error_svg__st2",
    d: "M382.5 158.3H779.9V300.8H382.5z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M422.9,192.1L422.9,192.1c4.3,0,7.7,3.4,7.7,7.7v57.6c0,4.3-3.4,7.7-7.7,7.7h0c-4.3,0-7.7-3.4-7.7-7.7v-57.6 C415.2,195.5,418.6,192.1,422.9,192.1z",
    opacity: 0.5,
    fill: "#c6c6c6"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "connection-error_svg__st6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "connection-error_svg__st7",
    d: "M453.3,192.1L453.3,192.1c4.3,0,7.7,3.4,7.7,7.7v57.6c0,4.3-3.4,7.7-7.7,7.7h0c-4.3,0-7.7-3.4-7.7-7.7v-57.6 C445.6,195.5,449,192.1,453.3,192.1z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "connection-error_svg__st8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "connection-error_svg__st7",
    d: "M483.7,192.1L483.7,192.1c4.3,0,7.7,3.4,7.7,7.7v57.6c0,4.3-3.4,7.7-7.7,7.7h0c-4.3,0-7.7-3.4-7.7-7.7v-57.6 C476,195.5,479.4,192.1,483.7,192.1z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    className: "connection-error_svg__st8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "connection-error_svg__st7",
    d: "M514.1,192.1L514.1,192.1c4.3,0,7.7,3.4,7.7,7.7v57.6c0,4.3-3.4,7.7-7.7,7.7l0,0c-4.3,0-7.7-3.4-7.7-7.7v-57.6 C506.4,195.5,509.8,192.1,514.1,192.1z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    className: "connection-error_svg__st6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "connection-error_svg__st7",
    d: "M544.5,192.1L544.5,192.1c4.3,0,7.7,3.4,7.7,7.7v57.6c0,4.3-3.4,7.7-7.7,7.7l0,0c-4.3,0-7.7-3.4-7.7-7.7v-57.6 C536.8,195.5,540.2,192.1,544.5,192.1z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    className: "connection-error_svg__st8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "connection-error_svg__st7",
    d: "M574.9,192.1L574.9,192.1c4.3,0,7.7,3.4,7.7,7.7v57.6c0,4.3-3.4,7.7-7.7,7.7l0,0c-4.3,0-7.7-3.4-7.7-7.7v-57.6 C567.2,195.5,570.6,192.1,574.9,192.1z"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    className: "connection-error_svg__st9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "connection-error_svg__st7",
    d: "M605.3,192.1L605.3,192.1c4.3,0,7.7,3.4,7.7,7.7v57.6c0,4.3-3.4,7.7-7.7,7.7l0,0c-4.3,0-7.7-3.4-7.7-7.7v-57.6 C597.6,195.5,601,192.1,605.3,192.1z"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "connection-error_svg__st2",
    d: "M382.5 10.2H779.9V152.7H382.5zM0 341.4H500V675.4H0z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "connection-error_svg__st7",
    d: "M422.9,44L422.9,44c4.3,0,7.7,3.4,7.7,7.7v57.6c0,4.3-3.4,7.7-7.7,7.7h0c-4.3,0-7.7-3.4-7.7-7.7V51.8 C415.2,47.5,418.6,44,422.9,44z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "connection-error_svg__st7",
    d: "M453.3,44L453.3,44c4.3,0,7.7,3.4,7.7,7.7v57.6c0,4.3-3.4,7.7-7.7,7.7h0c-4.3,0-7.7-3.4-7.7-7.7V51.8 C445.6,47.5,449,44,453.3,44z",
    opacity: 0.9
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    className: "connection-error_svg__st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "connection-error_svg__st7",
    d: "M483.7,44L483.7,44c4.3,0,7.7,3.4,7.7,7.7v57.6c0,4.3-3.4,7.7-7.7,7.7h0c-4.3,0-7.7-3.4-7.7-7.7V51.8 C476,47.5,479.4,44,483.7,44z"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "connection-error_svg__st7",
    d: "M514.1 44L514.1 44c4.3 0 7.7 3.4 7.7 7.7v57.6c0 4.3-3.4 7.7-7.7 7.7l0 0c-4.3 0-7.7-3.4-7.7-7.7V51.8C506.4 47.5 509.8 44 514.1 44zM544.5 44L544.5 44c4.3 0 7.7 3.4 7.7 7.7v57.6c0 4.3-3.4 7.7-7.7 7.7l0 0c-4.3 0-7.7-3.4-7.7-7.7V51.8C536.8 47.5 540.2 44 544.5 44zM574.9 44L574.9 44c4.3 0 7.7 3.4 7.7 7.7v57.6c0 4.3-3.4 7.7-7.7 7.7l0 0c-4.3 0-7.7-3.4-7.7-7.7V51.8C567.2 47.5 570.6 44 574.9 44zM605.3 44L605.3 44c4.3 0 7.7 3.4 7.7 7.7v57.6c0 4.3-3.4 7.7-7.7 7.7l0 0c-4.3 0-7.7-3.4-7.7-7.7V51.8C597.6 47.5 601 44 605.3 44z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#d40400",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeDasharray: 12,
    d: "M159.8 306.4L159.8 99.4 330.8 99.4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M180.6,194.5h-14.8l5.5-16.6c0.5-1.9-1-3.9-3-3.9h-18.4c-1.5,0-2.8,1.1-3,2.7l-4.1,30.7 c-0.2,1.8,1.2,3.5,3,3.5h15.2l-5.9,24.9c-0.5,1.9,1,3.8,3,3.8c1.1,0,2.1-0.6,2.7-1.5l22.5-38.9C184.4,197,182.9,194.5,180.6,194.5z",
    fill: "#c9c9c9"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "connection-error_svg__st14",
    d: "M636.8 477.4L636.8 639.4 546.8 639.4"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "connection-error_svg__st14",
    d: "M690.8 513.4L690.8 675.4 600.8 675.4"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "connection-error_svg__SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 727,
    y1: 621.12,
    x2: 727,
    y2: 571.92,
    gradientTransform: "matrix(1 0 0 -1 0 678)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M717,56.9h20c8.1,0,14.6,6.5,14.6,14.6v20c0,8.1-6.5,14.6-14.6,14.6h-20c-8.1,0-14.6-6.5-14.6-14.6v-20 C702.4,63.4,708.9,56.9,717,56.9z",
    fill: "url(#connection-error_svg__SVGID_2_)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "connection-error_svg__st7",
    d: "M720.2 60.1h13.5c8.1 0 14.6 6.5 14.6 14.6v13.5c0 8.1-6.5 14.6-14.6 14.6h-13.5c-8.1 0-14.6-6.5-14.6-14.6V74.7C705.7 66.7 712.2 60.1 720.2 60.1zM717 203.9h20c8.1 0 14.6 6.5 14.6 14.6v20c0 8.1-6.5 14.6-14.6 14.6h-20c-8.1 0-14.6-6.5-14.6-14.6v-20C702.4 210.5 708.9 203.9 717 203.9z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "connection-error_svg__st7",
    d: "M720.2 207.2h13.5c8.1 0 14.6 6.5 14.6 14.6v13.5c0 8.1-6.5 14.6-14.6 14.6h-13.5c-8.1 0-14.6-6.5-14.6-14.6v-13.5C705.7 213.7 712.2 207.2 720.2 207.2zM717 352h20c8.1 0 14.6 6.5 14.6 14.6v20c0 8.1-6.5 14.6-14.6 14.6h-20c-8.1 0-14.6-6.5-14.6-14.6v-20C702.4 358.5 708.9 352 717 352z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "connection-error_svg__st7",
    d: "M720.2,355.2h13.5c8.1,0,14.6,6.5,14.6,14.6v13.5c0,8.1-6.5,14.6-14.6,14.6h-13.5c-8.1,0-14.6-6.5-14.6-14.6 v-13.5C705.7,361.7,712.2,355.2,720.2,355.2z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "connection-error_svg__st16",
    d: "M469.5,457.6H199.9v-57.9h269.6V457.6z M201.1,456.4h267.2V401H201.1V456.4z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "connection-error_svg__st17",
    d: "M181.5 411.3H449.9V468H181.5z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "connection-error_svg__st17",
    cx: 11.9,
    cy: 353,
    rx: 4.2,
    ry: 4.3
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "connection-error_svg__st17",
    cx: 26.1,
    cy: 353,
    rx: 4.2,
    ry: 4.3
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "connection-error_svg__st17",
    cx: 40.4,
    cy: 353,
    rx: 4.2,
    ry: 4.3
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "connection-error_svg__st16",
    d: "M500,675.4H0v-334h500V675.4z M1.2,674.2h497.6V342.6H1.2V674.2z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "connection-error_svg__st16",
    d: "M.6 359.9H499.40000000000003V361.09999999999997H.6zM13.1 356c-2.7.1-4.9-2.1-5-4.7-.1-2.7 2.1-4.9 4.7-5 2.7-.1 4.9 2.1 5 4.7 0 0 0 .1 0 .1C17.8 353.8 15.7 356 13.1 356zM13.1 347.5c-2 0-3.7 1.5-3.7 3.6 0 2 1.5 3.7 3.6 3.7s3.7-1.5 3.7-3.6c0 0 0-.1 0-.1C16.7 349.1 15.1 347.5 13.1 347.5zM27.3 356c-2.7.1-4.9-2.1-5-4.7-.1-2.7 2.1-4.9 4.7-5 2.7-.1 4.9 2.1 5 4.7 0 0 0 .1 0 .1C32.1 353.8 30 356 27.3 356zM27.3 347.5c-2 0-3.7 1.5-3.7 3.6 0 2 1.5 3.7 3.6 3.7s3.7-1.5 3.7-3.6c0 0 0-.1 0-.1C30.9 349.1 29.3 347.5 27.3 347.5zM41.6 356c-2.7.1-4.9-2.1-5-4.7-.1-2.7 2.1-4.9 4.7-5 2.7-.1 4.9 2.1 5 4.7 0 0 0 .1 0 .1l0 0C46.3 353.8 44.2 356 41.6 356zM41.6 347.5c-2-.1-3.7 1.5-3.8 3.6-.1 2 1.5 3.7 3.6 3.8s3.7-1.5 3.8-3.6c0 0 0-.1 0-.1l0 0C45.2 349.1 43.6 347.5 41.6 347.5z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "connection-error_svg__st16",
    d: "M156.6 360.5H157.79999999999998V675.3H156.6z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "connection-error_svg__st18",
    d: "M213.3 515.2H300.6V527.4000000000001H213.3zM350.5 515.2H437.8V527.4000000000001H350.5z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "connection-error_svg__st16",
    d: "M305.9,521.9h-88.5v-13.4h88.5V521.9z M218.7,520.7h86.1v-11h-86.1V520.7z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "connection-error_svg__st18",
    d: "M213.3 609.7H300.6V621.9000000000001H213.3z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "connection-error_svg__st16",
    d: "M305.9,616.4h-88.5V603h88.5V616.4z M218.7,615.2h86.1v-11h-86.1V615.2z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "connection-error_svg__st18",
    d: "M213.6 561.2H438V573.4000000000001H213.6z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "connection-error_svg__st16",
    d: "M443.4 569.2H217.8v-13.4h225.6V569.2zM218.9 568h223.3v-11H218.9V568zM443.1 521.9h-88.5v-13.4h88.5L443.1 521.9zM355.8 520.7h86.1v-11h-86.1L355.8 520.7zM82.7 558.1c-27 0-48.8-22.5-48.8-50.1 0-27.7 21.9-50.1 48.8-50.1s48.8 22.4 48.8 50.1C131.5 535.6 109.6 558 82.7 558.1zM82.7 459.3c-26.2 0-47.4 21.8-47.4 48.6 0 26.9 21.2 48.6 47.4 48.6s47.4-21.8 47.4-48.6C130 481.1 108.8 459.4 82.7 459.3L82.7 459.3z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M77.4,509.6l-1.5-23.1c-0.3-4.5-0.4-7.7-0.4-9.7c0-2.7,0.7-4.8,2.1-6.2s3.2-2.2,5.5-2.2c2.8,0,4.6,1,5.5,2.9 c0.9,1.9,1.4,4.7,1.4,8.3c0,2.1-0.1,4.3-0.3,6.5l-2.1,23.8c-0.2,2.8-0.7,5-1.4,6.5c-0.7,1.5-2,2.3-3.7,2.3c-1.7,0-2.9-0.7-3.6-2.2 C78.1,514.8,77.6,512.6,77.4,509.6z M82.7,541.3c-2,0-3.7-0.6-5.1-1.9s-2.2-3-2.2-5.3c0-2,0.7-3.7,2.1-5.1s3.1-2.1,5.1-2.1 s3.8,0.7,5.2,2.1c1.4,1.4,2.1,3.1,2.1,5.1c0,2.3-0.7,4-2.2,5.3S84.6,541.3,82.7,541.3z"
  })));
}

export default SvgConnectionError;